import TypesUtils from "./typesUtils";

class ArraysUtils {
  static getMaxSizeSubArray(col) {
    let max = -1;
    col.forEach((subCol) => {
      if (subCol && subCol.constructor === Array) {
        if (max < 0 || subCol.length > max) max = subCol.length;
      }
    });
    return max;
  }

  static remove(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) {
      arr.splice(index, 1);
    }
  }

  static arrayToObj(array, fnValue) {
    let res = {};
    array.forEach((item, i) => {
      if (TypesUtils.isStr(item)) {
        let value = i;
        if (fnValue) {
          value = fnValue(item, i);
        }
        res[i] = value;
      }
    });
    return res;
  }

  static fill2d(lengthX, lengthY, val) {
    let x = new Array(lengthX);
    for (var i = 0; i < x.length; i++) {
      x[i] = new Array(lengthY).fill(val);
    }
    return x;
  }

  static equalsContents(arr1, arr2) {
    if (arr1 === null && arr2 === null) return true;
    if (
      !Array.isArray(arr1) ||
      !Array.isArray(arr2) ||
      arr1.length !== arr2.length
    )
      return false;
    return arr1.every((item) => {
      return arr2.indexOf(item) >= 0;
    });
  }

  static array2DToStrSep(rows,colTitles,rowSep="\r\n",cellSep=","){
    let data= "";
    if (colTitles){
      data = colTitles.join(',')+'\r\n';
    }
    if (rows) {
      rows.forEach((row) => {
        row.forEach((cell,index)=>{
          let text= cell;
          if (TypesUtils.isArray(cell)){
            text= cell.join(". ");
          }
          data+= text;
          if (index < row.length - 1)
            data+= cellSep;
        })
        data+= rowSep;
      });
    }
    return data;
  }

  static findInValueLabelArray(arr,value){
    let res= null;
    arr.some(item=>{
      if (item.value === value){
        res= item;
        return true;
      }
      return false;
    });
    return res;
  }
}

export default ArraysUtils;
